import { render, staticRenderFns } from "./upload-hand.vue?vue&type=template&id=052d5aea&scoped=true&"
import script from "./upload-hand.vue?vue&type=script&lang=ts&"
export * from "./upload-hand.vue?vue&type=script&lang=ts&"
import style0 from "./upload-hand.vue?vue&type=style&index=0&id=052d5aea&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052d5aea",
  null
  
)

export default component.exports